// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import NoDataCell from './NoDataCell';

type Props = {
  value: number;
  className?: string;
  onClick?: () => void;
  id?: string;
};

const LipperScoreCell: React.FunctionComponent<Props> = ({ value, className, onClick, id }: Props) => {
  if (value == null) {
    return <NoDataCell onClick={onClick} id={id} />;
  }

  return (
    <div className={classNames(className, 'cell lipper-score-cell', { filled: value === 5 })} onClick={onClick} id={id ? `cell-${id}` : undefined}>
      <div className="markup-container">
        <div className="lipper-score-pastille">
          <span>{value}</span>
        </div>
      </div>
    </div>
  );
};

export default LipperScoreCell;
